import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    overflow: 'auto',
    height: '100%',
    backgroundColor: theme.palette.background.default,
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(3.5, 22.375, 5),
  },
  modalContent: {
    padding: theme.spacing(0),
  },
}));
